import { Box, Divider, Grid, ListItem, Paper, Stack } from '@mui/material'
import { memo, useCallback } from 'react'

/**
 * Structure-only placeholder for shimmer-from-structure.
 */
function SecurityOverviewSkeleton() {
    const renderIndexComponent = useCallback(() => {
        const indexComponentView = []
        for (let i = 0; i < 15; i++) {
            indexComponentView.push(
                <ListItem key={i} sx={{ borderBottom: 0.5, borderColor: 'divider' }}>
                    <Grid container>
                        <Grid item xs={5}>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Box sx={{ width: 22, height: 22, borderRadius: '50%' }} />
                                <Box sx={{ width: 100, height: 15 }} />
                                <Box sx={{ width: 10, height: 15 }} />
                            </Stack>
                        </Grid>
                        <Stack direction="row" alignItems="end" justifyContent="flex-end" flexGrow={1} spacing={1}>
                            <Box sx={{ width: 40, height: 15 }} />
                            <Box sx={{ width: 40, height: 15 }} />
                            <Box sx={{ width: 40, height: 15 }} />
                        </Stack>
                    </Grid>
                </ListItem>
            )
        }
        return indexComponentView
    }, [])

    const renderFieldValues = useCallback(() => {
        const fields = []
        for (let i = 0; i < 8; i++) {
            fields.push(
                <Grid key={i} item xs={6}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Box sx={{ width: 100, height: 15 }} />
                        <Box sx={{ width: 100, height: 15 }} />
                    </div>
                </Grid>
            )
        }
        return fields
    }, [])

    const renderFieldGroups = useCallback(() => {
        const fieldGroups = []
        for (let i = 0; i < 3; i++) {
            fieldGroups.push(
                <Box key={i} sx={{ boxShadow: 0 }}>
                    <Box sx={{ margin: '16px', width: 100, height: 15 }} />
                    <Grid container rowSpacing={3} sx={{ padding: '16px' }}>
                        {renderFieldValues()}
                    </Grid>
                    <Divider />
                </Box>
            )
        }
        return fieldGroups
    }, [renderFieldValues])

    return (
        <Paper sx={{ display: 'flex', height: '100%', flexDirection: 'column', borderRadius: '6px', overflowY: 'auto' }}>
            <Box>
                <Box sx={{ display: 'flex', width: '100%', flexDirection: 'column', alignItems: 'flex-start', borderTopRightRadius: '6px' }}>
                    <Paper className="sticky" sx={{ display: 'flex', width: '100%', flexDirection: 'column', alignItems: 'flex-start', paddingY: 1, zIndex: 10, paddingLeft: 2 }}>
                        <Stack direction="row" spacing={1}>
                            <Box sx={{ width: 100, height: 15 }} />
                            <Box sx={{ width: 10, height: 15 }} />
                        </Stack>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <Stack direction="row" alignItems="center" spacing={1}>
                                <Box sx={{ width: 22, height: 22, borderRadius: '50%' }} />
                                <Box sx={{ width: 100, height: 15 }} />
                            </Stack>
                        </Box>
                    </Paper>
                    <Box sx={{ width: '100%', height: 150 }} />
                </Box>
                <Box sx={{ boxShadow: 0, width: '100%' }}>
                    <Paper className="sticky" sx={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between', top: 0, zIndex: 10, padding: 2, boxShadow: 0 }}>
                        <Box sx={{ width: 100, height: 15 }} />
                        <Box sx={{ width: 100, height: 25 }} />
                    </Paper>
                </Box>
                {renderIndexComponent()}
                {renderFieldGroups()}
            </Box>
        </Paper>
    )
}

export default memo(SecurityOverviewSkeleton)